export default __webpack_public_path__ + "static/media/hoopia_imagotipo.9c1696f1.svg";